export const encodeHTMLEntities = value => {
  const htmlEntities = {
    '<': '&lt;',
    '>': '&gt;'
  };
  return value && value.replace(/([<>])/g, match => htmlEntities[match]);
};